// CustomFormItem.jsx
import { Form, Input } from "antd";

export default function CustomFormItem({
  label,
  name,
  placeholder,
  ...rest
}) {
  return (
    <Form.Item
      label={<span className="text-black font-cinzel text-[18px]">{label}</span>}
      name={name}
      {...rest}
    >
      <Input
        placeholder={placeholder}
        className="border border-gray-300 rounded-lg p-2 text-base 
                   focus:border-blue-500 focus:ring-1 focus:ring-blue-500 
                   transition-all duration-300"
      />
    </Form.Item>
  );
}
